import { formatIQD } from '../../shared/format.js';

// وجهة كل نتيجة.
//
// القاعدة: نفتح السجلّ نفسه لا الشاشة العامة. حيث توجد شاشة تفصيلية جاهزة
// بمسار حقيقي (فاتورة الشراء) نذهب إليها مباشرة؛ وما عداها يفتح على
// `/search/:type/:id` — بطاقة السجل الكامل، ومنها أزرار للشاشة المختصة.
export function resultPath(groupKey, item) {
  switch (groupKey) {
    case 'children': return `/search/child/${item.id}`;
    case 'guardians': return `/search/guardian/${item.id}`;
    case 'customers': return `/search/customer/${item.id}`;
    case 'products': return `/search/product/${item.id}`;
    case 'suppliers': return `/search/supplier/${item.id}`;
    case 'invoices':
      return item.kind === 'purchase' ? `/purchase/${item.id}` : `/search/invoice/${item.id}`;
    default: return '/dashboard';
  }
}

export const SESSION_STATUS_LABEL = {
  active: 'داخل القاعة',
  expired: 'تجاوز الوقت',
  exited: 'خرج',
  blocked: 'محظور'
};

export const SALES_STATUS_LABEL = {
  paid: 'مسددة',
  pending: 'معلقة',
  partial: 'مسددة جزئياً',
  cancelled: 'ملغاة'
};

export const PURCHASE_STATUS_LABEL = {
  draft: 'مسودة',
  posted: 'مرحّلة',
  cancelled: 'ملغاة'
};

export const POS_TYPE_LABEL = {
  cafeteria: 'كافتيريا',
  toys: 'ألعاب',
  checkout: 'محاسبة',
  play_fee: 'رسم لعب',
  manual: 'يدوية'
};

/** العنوان الرئيسي لسطر النتيجة. */
export function resultTitle(groupKey, item) {
  if (groupKey === 'invoices') {
    return `${item.kind === 'purchase' ? 'فاتورة شراء' : 'فاتورة مبيعات'} ${item.number}`;
  }
  return item.name || '—';
}

/** سطر فرعي قصير يميّز النتيجة عن غيرها. */
export function resultSubtitle(groupKey, item) {
  switch (groupKey) {
    case 'children': {
      const parts = [];
      if (item.guardianName) parts.push(`ولي الأمر: ${item.guardianName}`);
      if (item.cardUid) parts.push(`كارت ${item.cardUid}`);
      if (item.sessionStatus) parts.push(SESSION_STATUS_LABEL[item.sessionStatus] || item.sessionStatus);
      return parts.join(' · ');
    }
    case 'guardians': {
      const parts = [item.phone];
      if (item.childrenCount) parts.push(`${item.childrenCount} أطفال: ${item.childrenNames.join('، ')}`);
      return parts.filter(Boolean).join(' · ');
    }
    case 'customers': {
      const parts = [item.phone, `${item.invoicesCount} فاتورة`];
      if (item.totalDue > 0) parts.push(`متبقٍ ${formatIQD(item.totalDue)}`);
      return parts.filter(Boolean).join(' · ');
    }
    case 'invoices': {
      const label = item.kind === 'purchase'
        ? PURCHASE_STATUS_LABEL[item.status]
        : SALES_STATUS_LABEL[item.status];
      const parts = [item.partyName, label || item.status];
      if (item.total != null) parts.push(formatIQD(item.total));
      return parts.filter(Boolean).join(' · ');
    }
    case 'products': {
      const parts = [item.sku];
      if (item.barcode) parts.push(item.barcode);
      if (item.salePrice != null) parts.push(formatIQD(item.salePrice));
      if (item.currentStock != null) parts.push(`المخزون ${item.currentStock}`);
      return parts.filter(Boolean).join(' · ');
    }
    case 'suppliers': {
      const parts = [item.phone];
      if (item.balance != null) parts.push(`الرصيد ${formatIQD(item.balance)}`);
      return parts.filter(Boolean).join(' · ');
    }
    default: return '';
  }
}
